import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import About from './pages/About'
import Trips from './pages/Trips'
import Contact from './pages/Contact'
import Header from './components/Header'
import Footer from './components/Footer'
import TripDetail from './pages/TripDetail'
import TururiPietonale from './pages/TururiPietonale'
import TururiRegionale from './pages/TururiRegionale'
import ExperienteInteractive from './pages/ExperienteInteractive'
import TermeniSiConditii from './components/Termenisiconditii'

function App() {
  return (
    <Router>
      <Header />

      <div style={{ minHeight: '80vh' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/trips" element={<Trips />} />
          <Route path="/trips/:slug" element={<TripDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/trips/tururi-pietonale" element={<TururiPietonale />} />
          <Route path="/trips/tururi-regionale" element={<TururiRegionale />} />
          <Route path="/trips/experiente-interactive" element={<ExperienteInteractive />} />  
          <Route path="/termeni-si-conditii" element={<TermeniSiConditii />} />
        </Routes>
      </div>

      <Footer />
    </Router>
  )
}

export default App
